import { render, staticRenderFns } from "./ConnectProducts.vue?vue&type=template&id=bb73138a&"
import script from "./ConnectProducts.vue?vue&type=script&lang=js&"
export * from "./ConnectProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports